import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgramadorService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  progEmail(fecha: any, serv: string, tmpl: string, mail: any, subj: string, text: string, cc?: any, file?: any, dias?: number) {
    let progDate = [];

    if (environment.emailProd === false) {
      mail = ['ricardo.pastran@agenciaeducacion.cl'];
    }

    // Comprueba si viene undefined las variables opcionales
    file = file === undefined ? [] : file;
    cc = cc === undefined ? [] : cc;
    dias = dias === undefined ? 5 : dias;

    // Prepara las fechas enviadas para apiRest
    fecha.forEach(date => {
      // Remplaza '-' por '/' para evitar que se pierda 1 dia al formatear
      date = new Date(date.slice(0, 10).replace(/-/g, '/'));
      // Resta los días establecidos a cada fecha
      date.setDate(date.getDate() - dias);

      let day = date.getDate().toString();
      let month = (date.getMonth() + 1).toString();
      let year = date.getFullYear().toString();

      month = month.length < 2 ? '0' + month : month;
      day = day.length < 2 ? '0' + day : day;

      progDate.push(`${year}${month}${day}`);
    });

    // console.log(`${this._apiRestService.APIURL.serv121}/${progDate}/srvc__${serv}__{"tmpl":"${tmpl}","mail":${JSON.stringify(mail)},"subj":"${subj}","text":{"text":"${text}"},"cc":${JSON.stringify(cc)},"file":${JSON.stringify(file)}}`);
    // https://stdag-desarrollo.agenciaeducacion.cl/srvc/121/20191107,20191111/srvc__9995__{"tmpl":"4","mail":["ricardo.pastran@agenciaeducacion.cl"],"subj":"Pago%20de%20Documentos","text":{"text":"Se%20informa%20que"},"cc":["ricardo.pastran@agenciaeducacion.cl","ricardo.pastran@agenciaeducacion.cl"],"file":[""]}

    return this.http.get(`${this._apiRestService.APIURL.serv121}/${progDate}/srvc__${serv}__{"tmpl":"${tmpl}","mail":${JSON.stringify(mail)},"subj":"${subj}","text":{"text":"${text}"},"cc":${JSON.stringify(cc)},"file":${JSON.stringify(file)}}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }));
  }
}
